import { PermissionService } from './../../../../service/permission.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

// Constants
import { GlobalSearchPath } from '../../constants/global-search-path';
import { ObjectNames } from "../../constants/object.names";
import { AccountModuleId, CaseModuleId, LeadModuleId, OpportunityModuleId } from '../../constants/modules.constant';
import { LeadServiceN } from 'src/app/leads-v2/services/lead.service';
import { MLAINS } from '../../models/ml.ai.model';
import { AppMainComponent } from 'src/app/app.main.component';
import { OpportunitiesService } from 'src/app/opportunities-v2/services/opportunity.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { ImportserialService } from '../../services/importserial.service';

interface AnchorData {
    name: string;
    extension: string;
    downloadLink: string;
}

@Component({
    selector: 'app-account-lead-detail-block',
    templateUrl: './account-lead-detail-block.component.html',
    styleUrls: ['./account-lead-detail-block.component.scss']
})

export class AccountLeadDetailBlockComponent implements OnInit , OnChanges {
    @Input() moduleId: number;
    @Input() column: any[] = [];
    @Input() data;
    @Input() qualifiedId = 0;
    @Input() mergeAccountSequenceNumber: boolean = false;
    @Output() acountDetailRowData = new EventEmitter<any>();
    @Output() leadDetailRowData = new EventEmitter<any>();
    @Output() reloadDetails = new EventEmitter<any>();
    column1: any[] = [];
    column2: any[] = [];
    column1Address;
    column2Address;
    scoreName: string;
    scoreToolTip: string = '';
    gradeToolTip: string = '';

    popUpColumns: any[] = [];
    dataId;
    moduleType = '';
    displayDetailPopup = false;
    popupHeader = '';
    paths = GlobalSearchPath;
    objectNames = ObjectNames;
    linkLeadFields = ['contactname', 'businessName', 'fullName', 'name', 'accountName', 'caseNo', 'assoName'];
    linkopportunityFields = ['accountName'];
    linkCasesFields = ['associationName'];
    linkFields:any = [];
    displayFilePreview: boolean = false;
    currentFile: any;

    associationTypeId: number = 0;
    leadsMLAIScore: MLAINS.LeadsMLAIScore;
    opportunityMLAIScore: MLAINS.OpportunityMLAIScore;

    leadScoreViewPermission: boolean = false;
    oppScoreViewPermission: boolean = false;

    phoneFields: string[] = ['contactphonemobile', 'contactphonehome', 'contactphonework', 'contactphonecp1', 'contactphonecp2', 'leadPhone', 'accountPhone', 'workphone'];

    //CRM Overview
    selectedChannelId: number = 0;
    selectedAccountChannelId: number = 0;
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number = 0;
    displayLeadViewEdit: boolean = false;
    selectedLeadId: number = 0;
    displayOpportunityViewEdit: boolean = false;
    opportunityEditViewId: number = 0;

    leadScoreColumn: any = null;
    leadGradeColumn: any = null;
    assestBaseUrl: string = environment.assestsBasePath;

    activityDate: string[] = ['latestEventDate', 'lastActivityDate', 'taskDueDate'];
    //decimal fractiondigits
    maximumFractionDigits: number = 2;

    constructor(
        private leadServiceN: LeadServiceN,
        private opportunityService: OpportunitiesService,
        private permissionService: PermissionService,
        private app: AppMainComponent,
        private importserialService: ImportserialService,
    ){
        this.setPermissions();
    }

    ngOnInit(): void {
        this.setFractionDigits();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.mergeAccountSequenceNumber) {
            this.mergeAccountSequenceNumber = changes.mergeAccountSequenceNumber?.currentValue;
            this.column?.length && this.setColumns();
        }

        if (changes.column?.currentValue) {
            this.column = changes.column?.currentValue;
            this.setColumns();
        }

        if (changes.data?.currentValue) {
            this.data = changes.data?.currentValue;

            if (this.data?.attachments != null) {
                this.data.attachmentLinks = this.processAttachmentData(this.data?.attachments);
            }

            if (this.column?.find(x => x.enabled && x.columnName == 'address')) {
                this.data['cityStateCountry'] = (this.data['city'] ? this.data['city'] + ', ' : '')
                    + (this.data['state'] ? this.data['state'] + ', ' : '')
                    + (this.data['country'] ? this.data['country'] + ', ' : '')
                    + (this.data['zipcode'] ? this.data['zipcode'] : '');
            }

            if (this.moduleId === LeadModuleId) {
                this.data.discription = this.data.description;
                if(this.leadScoreViewPermission){
                    this.leadsMLAIScore = null;
                    this.scoreName = "Lead Score";
                    this.scoreToolTip = MLAINS.LeadsMLAIScoreConstantText.leadScoringInfo;
                    this.gradeToolTip = MLAINS.LeadsMLAIScoreConstantText.leadGradeInfo;
                    this.linkFields = this.linkLeadFields;
                    this.getLeadsMLAIScore();
                }
               
            } else if (this.moduleId === AccountModuleId) {
                this.scoreName = "Account Score";
                this.scoreToolTip = MLAINS.LeadsMLAIScoreConstantText.accountScoringInfo;
                this.gradeToolTip = MLAINS.LeadsMLAIScoreConstantText.accountGradeInfo;
                this.linkFields = this.linkLeadFields;
            } else if (this.moduleId == OpportunityModuleId) {
                this.scoreName = "Opportunity Score";
                this.scoreToolTip = MLAINS.LeadsMLAIScoreConstantText.opportunityScoringInfo;
                this.gradeToolTip = MLAINS.LeadsMLAIScoreConstantText.opportunityGradeInfo;
                this.linkFields = this.linkopportunityFields;
                this.getOpportunityMLAIScore();
            }else if(this.moduleId == CaseModuleId){
                if(this.data.caseAssociationName === 'Organization'){
                    this.linkCasesFields = [];
                }else{
                    this.linkFields = this.linkCasesFields;
                }
            }
            // console.log(this.data);
        }
    }

    setColumns(){
        let checkedColumn = this.column.filter(x => x.enabled && !(x.columnName == 'sequenceNumber' && this.mergeAccountSequenceNumber) && !['leadScore','leadGrade','scoreTrend'].includes(x.columnName));
        this.leadScoreColumn = this.column.find(x => x.enabled && x.columnName=='leadScore');
        this.leadGradeColumn = this.column.find(x => x.enabled && x.columnName=='leadGrade');

        if (checkedColumn.length > 6) {
            this.column1 = checkedColumn.slice(0, 6);
            this.column2 = checkedColumn.slice(6, 12);
        } else {
            this.column1 = checkedColumn;
            this.column2 = [];
        }

        this.column1Address = this.column1.find(x => x.columnName == 'address');
        this.column2Address = this.column2.find(x => x.columnName == 'address');
    }

    setPermissions(){
        const userPermissions = this.permissionService.getPemrissionData();

        if (userPermissions.length) {
            let leadScorePermission = userPermissions.find(obj => obj.objectName === ObjectNames.LEAD_SCORE);
            let oppScorePermission = userPermissions.find(obj => obj.objectName === ObjectNames.OPPORTUNITY_SCORE);

            if (leadScorePermission?.permissions) {
                leadScorePermission.permissions = leadScorePermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
                this.leadScoreViewPermission = leadScorePermission && (leadScorePermission.permissions[0].permissionId == 1 && leadScorePermission.permissions[0].statusId == 1) ? true : false;
            }

            if (oppScorePermission?.permissions) {
                oppScorePermission.permissions = oppScorePermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
                this.oppScoreViewPermission = oppScorePermission && (oppScorePermission.permissions[0].permissionId == 1 && oppScorePermission.permissions[0].statusId == 1) ? true : false;
            }
        }
    }

    setDetailsPopupData(columnName,data) {
        this.popUpColumns = [];

        if(this.moduleId === CaseModuleId){
            this.displayDetailPopup = false;
        }

        if (this.moduleId === LeadModuleId) {
            if (columnName === 'contactname') {
                this.displayDetailPopup = true;
                this.moduleType = this.objectNames.CONTACT;
                this.popupHeader = 'Contact Details';
                let contact = this.data?.leadContacts && this.data?.leadContacts.length > 0 ?
                    this.data?.leadContacts.find(x => x.contact && x.contact.isPrimaryContact) : 0
                this.dataId = contact ? contact?.contactId : 0;
                this.associationTypeId = contact?.contact?.contactAssociationTypeId || this.data?.contact?.contactAssociationId;
            } else if (columnName === 'businessName') {
                this.openLeadViewEdit(this.data.id, this.data?.typeId);
            }
        } else if (this.moduleId === AccountModuleId) {
            if (columnName === 'businessName') {
                this.openAccountViewEdit(this.data?.id);
            } else if (columnName === 'contactname') {
                this.displayDetailPopup = true;
                this.moduleType = this.objectNames.CONTACT;
                this.popupHeader = 'Contact Details';
                let contact = this.data?.accountContacts && this.data?.accountContacts.length > 0 ?
                    this.data?.accountContacts.find(x => x.contact && x.contact.isPrimaryContact) : 0
                this.dataId = contact ? contact?.contactId : 0;
                this.associationTypeId = contact?.contact?.contactAssociationTypeId || this.data?.contact?.contactAssociationId;
            }
        } else if (this.moduleId == OpportunityModuleId) {
            if (columnName === 'name') {
                this.openOpportunityViewEdit(this.data.id, this.data?.pipelineId);
            } else if (columnName === 'accountName') {
                this.openAccountViewEdit(this.data.accountId);
            }
        }else if(this.moduleId == CaseModuleId){
            if (columnName === 'ticketNo') {
                this.moduleType = this.objectNames.CASES;
                this.popupHeader = 'Case Details';
                this.dataId = this.data.id;
                this.popUpColumns = this.column;
            }
            else if (columnName === 'associationName') {
                if (this.data.caseAssociationName === 'Lead') {
                    this.openLeadViewEdit(this.data.associationId, 0);
                } else if (this.data.caseAssociationName === 'Account') {
                    this.openAccountViewEdit(this.data.associationId);
                }
            }
        }
    }

    processAttachmentData(attachments: Array<any>): AnchorData[] {
        let allLinks: AnchorData[] = [];

        for (let i = 0; i < attachments.length; i++) {
            allLinks.push({
                name: attachments[i]?.name || '',
                extension: attachments[i]?.extension || '',
                downloadLink: attachments[i]?.downloadLink || ''
            });
        }

        return allLinks;
    }

    openFilePreview(file: any): void {
        if(file?.attachmentId){
            this.displayFilePreview = true;
            this.currentFile = file;
        }
    }

    closeFilePreview() {
        this.displayFilePreview = false;
    }

    closeDialog() {
        this.displayDetailPopup = false;
    }

    getLeadsMLAIScore(): void {
        this.leadServiceN.getLeadsMLAIScore(this.data.id).subscribe((res: MLAINS.LeadsMLAIScore) => {
            this.leadsMLAIScore = res;
            if (this.leadsMLAIScore?.lastUpdatedDate) {
                this.leadsMLAIScore.lastUpdatedDate = this.app._showDateTimeWithZone(new Date(this.leadsMLAIScore?.lastUpdatedDate));
            }
            if (this.leadsMLAIScore) {

                if (this.leadsMLAIScore?.differenceFromLastScore > 0) {
                    this.leadsMLAIScore.graphIconName = MLAINS.MLAIScoreImprovingIconModel.improving;
                    this.leadsMLAIScore.differenceFromLastScoreText = `+${this.leadsMLAIScore?.differenceFromLastScore}`;
                }
                else if (this.leadsMLAIScore?.differenceFromLastScore < 0) {
                    this.leadsMLAIScore.graphIconName = MLAINS.MLAIScoreImprovingIconModel.down;
                    this.leadsMLAIScore.differenceFromLastScoreText = `${this.leadsMLAIScore?.differenceFromLastScore}`;
                }
                else {
                    this.leadsMLAIScore.graphIconName = MLAINS.MLAIScoreImprovingIconModel.steady;
                    this.leadsMLAIScore.differenceFromLastScoreText = ``;
                }
            }

        });
    }

    get leadScoreStaticFactors(){
        const staticFactors = this.leadsMLAIScore?.staticFactors?.filter(item=> item.text === 'Positive')??[];
        return staticFactors;
    }

    get leadScoreOtherFactors(){
        const misingInformations = this.leadsMLAIScore?.otherFactors?.filter(item=> item.available === false)??[];
        return misingInformations;
    }

    get opportunityScoreStaticFactors(){
        const staticFactors = this.opportunityMLAIScore?.staticFactors?.filter(item=> item.text === 'Positive')??[];
        return staticFactors;
    }

    get opportunityScoreOtherFactors(){
        const misingInformations = this.opportunityMLAIScore?.otherFactors?.filter(item=> item.available === false)??[];
        return misingInformations;
    }

    getOpportunityMLAIScore(): void {
        this.opportunityService.getOpportunityMLAIScore(this.data.id).subscribe((res: MLAINS.OpportunityMLAIScore) => {
            this.opportunityMLAIScore = res;
            if (this.opportunityMLAIScore?.lastUpdatedDate) {
                this.opportunityMLAIScore.lastUpdatedDate = new Date(this.opportunityMLAIScore?.lastUpdatedDate);
            }
            if (this.opportunityMLAIScore) {
                if (this.opportunityMLAIScore?.differenceFromLastScore > 0) {
                    this.opportunityMLAIScore.graphIconName = MLAINS.MLAIScoreImprovingIconModel.improving;
                    this.opportunityMLAIScore.differenceFromLastScoreText = `+${this.opportunityMLAIScore?.differenceFromLastScore}`;
                }
                else if (this.opportunityMLAIScore?.differenceFromLastScore < 0) {
                    this.opportunityMLAIScore.graphIconName = MLAINS.MLAIScoreImprovingIconModel.down;
                    this.opportunityMLAIScore.differenceFromLastScoreText = `${this.opportunityMLAIScore?.differenceFromLastScore}`;
                }
                else {
                    this.opportunityMLAIScore.graphIconName = MLAINS.MLAIScoreImprovingIconModel.steady;
                    this.opportunityMLAIScore.differenceFromLastScoreText = ``;
                }
            }
        });
    }

    openAccountViewPopUp(rowData: any) {
        this.acountDetailRowData.emit(rowData)
    }

    openleadViewPopUp(rowData: any) {
        this.leadDetailRowData.emit(rowData)
    }

    reloadResultAfterSave() {
        this.reloadDetails.emit(this.data);
    }

    openAccountViewEdit(accountId: number) {
        this.displayAccountViewEdit = true;
        this.selectedAccountId = accountId;
    }

    closeAccountViewEditModal() {
        this.displayAccountViewEdit = false;
        this.selectedAccountId = 0;
    }

    openLeadViewEdit(leadId: number, channelId: number) {
        this.displayLeadViewEdit = true;
        this.selectedChannelId = channelId;
        this.selectedLeadId = leadId;
    }

    closeLeadViewEdit() {
        this.displayLeadViewEdit = false;
        this.selectedLeadId = 0;
    }

    openOpportunityViewEdit(opportunityId: number, channelId: number) {
        this.displayOpportunityViewEdit = true;
        this.selectedChannelId = channelId;
        this.opportunityEditViewId = opportunityId;
    }

    closeOpportunityViewEdit() {
        this.displayOpportunityViewEdit = false;
        this.opportunityEditViewId = 0;
    }

    getDateClass(isoDate: string): string {
        if (!isoDate) {
            return ''; // Return default class if no date is provided
        }
        const currentDateTimeUTC = moment(this.app._showDateTimeWithZone(new Date())).utc();
        const checkDateUTC = moment(this.app._showDateTimeWithZone(isoDate)).utc();
    
        if (checkDateUTC.isBefore(currentDateTimeUTC)) {
            return 'past-date'; // Overdue
        }

        if (checkDateUTC.isSame(currentDateTimeUTC, 'day')) {
            return 'current-date'; // Today's 
        }
        return 'upcoming-date'; // Upcoming 
    }    
      

      getDateTooltip(dateClass: string): string {
        switch (dateClass) {
          case 'past-date':
            return 'Overdue Task';
          case 'upcoming-date':
            return 'Due Task';
          case 'current-date':
            return 'Today\'s Task';
          default:
            return '';
        }
      }

      getEventTooltip(dateClass: string): string {
        switch (dateClass) {
          case 'past-date':
            return 'Past Event';
          case 'upcoming-date':
            return 'Upcoming Event';
          case 'current-date':
            return 'Today\'s Event';
          default:
            return '';
        }
      } 
      
      setFractionDigits(){
        this.importserialService.getDecimalValue().subscribe(value=>{
            this.maximumFractionDigits = value||this.maximumFractionDigits;
        });
    }

}
